import React from 'react'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import { PASSWORD_RULES } from '../utils/accountRecovery'

/**
 * Live checklist of the password policy, shown under the password field on sign-up and reset.
 */
const PasswordRules = ({ password }: { password:string }) => (
	<Box sx={{ mt:1, mb:1 }}>
		<Typography variant="body2" color="text.secondary">Your password needs:</Typography>
		{PASSWORD_RULES.map(rule => {
			const ok = rule.test(password||'')
			return <Typography key={rule.label} variant="body2" color={ok ? 'success.main' : 'text.secondary'}>
				{ok ? '✓' : '•'} {rule.label}
			</Typography>
		})}
	</Box>
)

export default PasswordRules
